import React from 'react'
import ViewIconSVG from "../../../assets/icons/eye.svg"
export const ViewIcon: React.FC = () => {
  return (
    <img src={ViewIconSVG} alt="" className="w-[18.33px] h-[13.33px] cursor-pointer" />
  )
}
